export enum ActionType {
  // creatte user
  NEW_STRESS_CHECK = "action/NEW_STRESS_CHECK",
  NEW_STRESS_CHECK_SUCCESS = "action/NEW_STRESS_CHECK_SUCCESS",
  NEW_STRESS_CHECK_ERROR = "action/NEW_STRESS_CHECK_ERROR",
  RESET_NEW_STRESS_CHECK = "action/RESET_NEW_STRESS_CHECK",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface NewStressCheckData {
  stress_check_type_id: number;
  name: string;
  start_time: string;
  end_time: string;
  is_temp_save?: string;
}
